import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useCallback, useEffect, useState } from 'react';
import { AutosuggestSearchParams } from '../services/SearchService';
import { useSearchService } from './serviceHooks';
import { SearchSuggestions } from '../types/mapped';

export type UseSearchSuggestionsParams = AutosuggestSearchParams & {
    request: IRequestContext;
    telemetry: ITelemetry;
};

export const useSearchSuggestions = (params: UseSearchSuggestionsParams) => {
    const {
        request,
        telemetry,
        numberOfCategoryResults,
        numberOfKeywordResults,
        numberOfProductResults,
        query,
        shouldFetchCategories,
        shouldFetchProducts,
        shouldFetchSearchTermPredictions
    } = params;
    const [suggestions, setSuggestions] = useState<SearchSuggestions>();
    const [isLoading, setIsLoading] = useState(false);

    const relewiseSearchService = useSearchService(request, telemetry);

    const fetchSuggestions = useCallback(async () => {
        if (!query) {
            setSuggestions(undefined);
            return;
        }

        setIsLoading(true);

        const result = await relewiseSearchService.autosuggestedSearch({
            numberOfCategoryResults,
            numberOfKeywordResults,
            numberOfProductResults,
            query,
            shouldFetchCategories,
            shouldFetchProducts,
            shouldFetchSearchTermPredictions
        });

        setSuggestions(result);
        setIsLoading(false);
    }, [
        numberOfCategoryResults,
        numberOfKeywordResults,
        numberOfProductResults,
        query,
        shouldFetchCategories,
        shouldFetchProducts,
        shouldFetchSearchTermPredictions,
        relewiseSearchService
    ]);

    useEffect(() => {
        fetchSuggestions();
    }, [query, fetchSuggestions]);

    return { suggestions, isLoading };
};
